import { AutogenLayoutMobileCommUnitAllLookup } from "./autogen/AutogenLayoutMobileCommUnitAllLookup";

export class MobileCommUnitAllLookup extends AutogenLayoutMobileCommUnitAllLookup {
}
